import React from 'react';
import { X } from 'lucide-react';
import { cn } from '@/lib/utils';

interface ChatContextChipProps {
  label: string;
  icon?: React.ReactNode;
  onClick?: () => void;
  onRemove?: () => void;
}

/** Attachment / add-context pill for the composer. */
const ChatContextChip: React.FC<ChatContextChipProps> = ({ label, icon, onClick, onRemove }) => (
  <span
    className={cn(
      'inline-flex h-7 max-w-[14rem] items-center gap-1.5 rounded-full border bg-card pl-2 text-xs',
      onRemove ? 'pr-1' : 'pr-2.5',
      onClick && 'transition-colors duration-150 ease-shell hover:border-primary/40 hover:bg-accent/60',
    )}
  >
    {icon && <span className="grid size-3.5 shrink-0 place-items-center text-muted-foreground [&_svg]:size-3.5">{icon}</span>}

    {onClick ? (
      <button type="button" onClick={onClick} className="min-w-0 truncate outline-hidden focus-visible:underline">
        {label}
      </button>
    ) : (
      <span className="min-w-0 truncate">{label}</span>
    )}

    {onRemove && (
      <button
        type="button"
        onClick={onRemove}
        aria-label={`${label} — remove`}
        className="grid size-5 shrink-0 place-items-center rounded-full text-muted-foreground transition-colors hover:bg-muted hover:text-foreground focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-ring"
      >
        <X className="size-3" strokeWidth={2.2} />
      </button>
    )}
  </span>
);

export default ChatContextChip;
